import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const authorIdResolver: FieldResolver = (metadata: Metadata) =>
  ({ authorId: metadata.getAuthorId() } as StreamData)

export default authorIdResolver
